// extracted by mini-css-extract-plugin
export default {"base":"App_base__lPkj+"};